module["exports"] = [
  "####-#####",
  "####-######"
];
